import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const downloadSaldosSlice = createSlice({
  name: 'downloadSaldos',
  initialState: {
    rows: []
  },
  reducers: {
    setSaldosToDownload: (state, action) => {
      state.rows = action.payload;
    }
  }
});

export const { setSaldosToDownload } = downloadSaldosSlice.actions;

// Action Creators
export const downloadSaldos = (comunidadId) => async (dispatch, getState) => {
  let item = LocalCache.get(`KEY:download-saldos&comunidad=${comunidadId}`);
  if (item) {
    dispatch(setSaldosToDownload(item));
  } else {
    try {
      const response = await API.get('ePlat', `/download-saldos?comunidad=${comunidadId}`);
      dispatch(setSaldosToDownload(response));
      LocalCache.put(`KEY:download-saldos&comunidad=${comunidadId}`, response);
    } catch (error) {
      console.log('DVD: ERROR Llamada a downloadSaldos()', error);
    }
  }
};

export default downloadSaldosSlice.reducer;
